import {
  addNavMenuItem,
  registerBulkAction,
  registerDataTableComponent,
} from "@bb-vendure/admin-ui/core";
import { bulkDeleteAction } from "./components/bulkDelete";
import { ArtistColumnComponent } from "./components/artist-column/artist-column.component";
export default [
  registerBulkAction(bulkDeleteAction),
  registerDataTableComponent({
    tableId: "product-list",
    columnId: "artist",
    component: ArtistColumnComponent,
  }),
];
